import { setErrors } from '@/store/error';

export const createErrors = (errors) => async (dispatch) => {
  dispatch(setErrors({ errors }));
};

export const clearErrors = () => async (dispatch) => {
  dispatch(setErrors({ errors: [] }));
};
